import React, { useEffect, useState } from "react";
import "./styles/Relacion_sevicio.css";
import Tabla_relacion from "../components/Tabla_relacion";
import MenuBar from "../components/MenuBar";
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";

//Relacion servicio
const Relacion_servicio = () =>{
       const navigate = useNavigate();
    /*Funcion para validar el tipo de session*/
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid !== "rid2"){
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }
    }

    useEffect(() =>{
        validarSesion();
    },[]);

    return(
        <div className="rootBoxTablaRelacion">
            <MenuBar pagina="Relacion" sesion={admin}/>
            <div className="containerBoxTablaRelacion">
                <div className="mainTablaBoxTablaRelacion">
                    <h1>Alumnos registrados</h1>
                    <Tabla_relacion saludo="Hola"/>
                </div>
            </div>
            
        </div>
    );
}

export default Relacion_servicio;